export interface Session {
  token: string;
  expiry: Date;
}

export interface DataError {
  errorType: string;
  message?: string;
}

export interface Event {
  type: string;
  recordedAt: Date;
  recording: Recording;
  medicationUse: MedicationUse;
  selfAssessment: SelfAssessment;
}

export interface Recording {
  wheezeRate: number;
  triggers: Trigger[];
  symptoms: Symptom[];
  recordingFile: RecordingFile;
}

export interface Trigger {
  type: string;
  value: string;
}

export interface Symptom {
  type: string;
  value: string;
}

interface RecordingFile {
  url: string;
}

export interface MedicationUse {
  dose: number;
  medication: Medication;
}

interface Medication {
  id: number;
  name: string;
  category: string;
}

interface SelfAssessment {
  breathingDifficulty: number;
  triggers: Trigger[];
  symptoms: Symptom[];
  notes: string;
}

export enum BreathingDifficulty {
  GOOD,
  FAIR,
  NOT_SO_GOOD,
  BAD,
  AWFUL
}

export enum EventType {
  RECORDING,
  MEDICATION_USE,
  SELF_ASSESSMENT
}

export enum MedicationCategory {
  RELIEVER,
  PREVENTER
}
